import React, {useState, useCallback, useEffect, useMemo} from "react";
import Banner from "../assets/images/banners/EnterToWin.jpg";
import imageMob from "../assets/images/banners/EnterToWin-mob.jpg";
import BuyTicket from "../assets/images/icons/BuyTicket.svg";
import { Link, useOutletContext, useNavigate, useSearchParams } from "react-router-dom";
import { handleApiCall } from "../apis";
import { endpoints } from "../utils/endpoints";
import { useLanguage } from "../context/LanguageContext";
import he from "he";
import parse from "html-react-parser";

const buildMediaUrl = (path = "") => {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;
  const base = (process.env.REACT_APP_API || "").replace(/\/+$/, "");
  if (!base) return path;
  const normalizedBase = base.replace(/\/v1$/i, "");
  return `${normalizedBase}/${path.replace(/^\/+/, "")}`;
};

function Thanks() {
  const { setBannerData } = useOutletContext();
  const { language } = useLanguage();
  const navigate = useNavigate();
  const [competitionData, setCompetitionData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const competition_id = searchParams.get("competition_id");

  const fetchCompetitionData = useCallback(async () => {
  if (!competition_id) return;

  setLoading(true);
  try {
    const response = await handleApiCall(
      "get",
      `${endpoints.saudiaCompetitionDetails}/${competition_id}`
    );

    if (
      response?.data?.code === 200 ||
      response?.data?.code === "200" ||
      response?.data?.success === true
    ) {
      setCompetitionData(response?.data?.data?.competition);
    } else {
      setCompetitionData(null);
    }
  } catch (error) {
    console.error("Details fetch error:", error);
    setCompetitionData(null);
  } finally {
    setLoading(false);
  }
}, [competition_id]);


  useEffect(() => {
    fetchCompetitionData();
  }, [fetchCompetitionData]);

  // Get title from API
  const title = useMemo(() => {
    if (competitionData) {
      const titleEn = competitionData?.title_en || competitionData?.title_english;
      const titleAr = competitionData?.title_ar || competitionData?.title_arabic;
      return language === "AR" ? (titleAr || titleEn || "Thanks for entering") : (titleEn || titleAr || "Thanks for entering");
    }
    return "Thanks for entering";
  }, [competitionData, language]);

  // 2. Thanks page title
  const thanksTitle = useMemo(() => {
    if (!competitionData) return "Thanks for entering";
    const en = competitionData?.thanks_page_title_en;
    const ar = competitionData?.thanks_page_title_ar;
    return language === "AR" ? (ar || en || "شكراً لمشاركتك") : (en || ar || "Thanks for entering");
  }, [competitionData, language]);

  // 3. Thanks page description
  const thanksDescription = useMemo(() => {
    if (!competitionData) return "";
    const en = competitionData?.thanks_page_discription_en;
    const ar = competitionData?.thanks_page_discription_ar;
    return language === "AR" ? (ar || en || "") : (en || ar || "");
  }, [competitionData, language]);

  // Get banner images from API or fallback
  const desktopBanner = useMemo(() => {
    if (competitionData?.desktop_banner || competitionData?.desktop_image) {
      return buildMediaUrl(competitionData.desktop_banner || competitionData.desktop_image);
    }
    //return Banner;
  }, [competitionData]);

  const mobileBanner = useMemo(() => {
    if (competitionData?.mobile_banner || competitionData?.mobile_image) {
      return buildMediaUrl(competitionData.mobile_banner || competitionData.mobile_image);
    }
    //return imageMob;
  }, [competitionData]);

  useEffect(() => {
    setBannerData({
      image: desktopBanner,
      MobileBanner: mobileBanner,
      title: title,
      subtitle: "",
      skew: false,
      bannershow: true,
      titleClass: "text-[30px] md:text-[4rem] leading-tight text-white font-SaudiaBold !hidden"
    });
  }, [setBannerData, desktopBanner, mobileBanner, title]);
  return (
    <>
      <div className="container max-w-8xl mx-auto px-2 py-8 md:py-0 md:px-8 2xl:px-32 grid md:grid-cols-12">
        <div className="mb-2 md:mb-20 gap-x-16 col-span-8 text-white">
          {loading ? (
            <p className="text-white/90 md:mb-10 text-lg font-SaudiaLight">
              {language === "AR" ? "جاري التحميل..." : "Loading..."}
            </p>
          ) : (
            // <h2 className="text-2xl text-[2.625rem] font-SaudiaRegular my-10">{title}</h2>
            <h2 className="text-3xl md:text-[2.625rem] font-SaudiaRegular mb-4 md:my-10">
              {thanksTitle}
            </h2>
          )}
          {/* <p className="text-white/90 mb-10 text-lg font-SaudiaLight">

          <p className="text-white/90 md:mb-10 text-lg font-SaudiaLight">
            {thanksDescription}
          </p> */}
          {/* <p
            className="text-white/90 md:mb-10 text-lg font-SaudiaLight"
            dangerouslySetInnerHTML={{
              __html: he.decode(thanksDescription || ""),
            }}
          /> */}
          <div
            className="
              text-white/90 mb-10 text-lg font-SaudiaLight
              prose prose-invert max-w-none
              [&_p]:mb-4
              [&_p:empty]:h-4
              [&_p:empty]:block
              [&_br]:block
            "
          >
            {parse(thanksDescription)}
          </div>

          {/* <p className="text-white/90 mb-4 text-lg font-SaudiaLight">
            Lorem ipsum dolor sit amet consectetur. Turpis a nec nisl arcu faucibus varius non nec. Sit diam mattis nisi elit. Habitant aliquam scelerisque consectetur maecenas sed mauris tellus vulputate tellus.
          </p>
          <p className="text-white/90 md:mb-10 text-lg font-SaudiaLight">
            Sed venenatis eget feugiat libero ultrices neque at in vitae. Donec ullamcorper leo commodo pulvinar est nunc id ut. Consectetur mauris sapien condimentum sed nulla cras velit facilisis vitae. Feugiat neque odio volutpat feugiat posuere bibendum nunc fringilla. 
          </p> */}
          {/* <div className="bg-[#D9D9D9] h-56 mr-28 mt-8"></div>
          <div className="bg-[#D9D9D9] h-56 mr-28 mt-8"></div> */}
          <button 
            onClick={() => navigate("/")}
            className="border border-white px-4 py-2.5 text-lg font-SaudiaRegular rounded-md mt-8 hover:bg-white hover:text-saudiaGreen transition-all"
          >
            {language === "AR" ? "العودة إلى الصفحة الرئيسية" : "Back to home"}
          </button>
        </div>
      </div>
    </>
  );
}

export default Thanks;
